import fetchData from "../api/Fetch";

export default async function fetchDevice(deviceID) {
  let response = await fetchData("device/" + deviceID);
  return response;
}
